const LoaderDivs = ({ className }) => {
  return (
    <div
      className={`bg-gray-200 dark:bg-light_secondary_label animate-pulse ${className}`}
    />
  );
};

export default LoaderDivs;
